import { render, staticRenderFns } from "./myResourceStoreManageList.vue?vue&type=template&id=cfa3e958&scoped=true"
import script from "./myResourceStoreManageList.vue?vue&type=script&lang=js"
export * from "./myResourceStoreManageList.vue?vue&type=script&lang=js"
import style0 from "./myResourceStoreManageList.vue?vue&type=style&index=0&id=cfa3e958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa3e958",
  null
  
)

export default component.exports